import { Button, Icons, Stack, Typography } from '@healthinal/ui';
import { useNavigate } from '@tanstack/react-router';
import { PatientBasicsDto, TaskDto } from '../../../api/generated/model';
import { SubCard } from '../../../components/SubCard.tsx';
import { formatLocalDateTimeWithGermanMonthDateOnly } from '../../../utils/date.ts';

export function TaskLabOrderCard({ task, patient }: { task: TaskDto; patient: PatientBasicsDto }) {
  const navigate = useNavigate();
  const patientName = [patient.firstName, patient.lastName].filter(Boolean).join(' ');
  const noteTitle = task.notes || task.labOrder?.notes || 'Keine Beschreibung des To Dos eingetragen';

  return (
    <Stack direction={'row'}>
      <Stack flex={1} gap={2}>
        <Stack direction={'row'} gap={2}>
          <SubCard>
            <Icons.BloodtypeOutlined size={'sm'} />
          </SubCard>
          <Stack justifyContent={'space-between'}>
            <Typography sx={{ whiteSpace: 'pre-line' }} level={'title-lg'}>
              {noteTitle}
            </Typography>
            <Typography level={'body-sm'}>{formatLocalDateTimeWithGermanMonthDateOnly(task.due)}</Typography>
          </Stack>
        </Stack>
        <Typography sx={{ whiteSpace: 'pre-line' }} level={'title-sm'}>
          {patientName}
        </Typography>
      </Stack>
      <Button
        sx={{ alignSelf: 'flex-start' }}
        endDecorator={<Icons.ArrowForward />}
        onClick={() => navigate({ to: '/patients/$patientId/diagnostics', params: { patientId: task.patientId } })}>
        Zur Diagnostik
      </Button>
    </Stack>
  );
}
